import { useIntl } from 'react-intl';

import { Box } from '~/eds/src/components/Box/Box';
import { ContentContainer } from '~/eds/src/components/ContentContainer/ContentContainer';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { DocumentViewer } from '~/features/document-viewer/DocumentViewer';
import { api } from '~/redux/api/createApi';
import { coerceRtkqError } from '~/redux/api/utils';
import { useRouting } from '~/routing/useRouting';

const Page = () => {
  const { getSearchParam } = useRouting();
  const intl = useIntl();

  const id = getSearchParam('id');

  const {
    data: file,
    error,
    isFetching,
  } = api.endpoints.getExternalDocument.useQuery({
    id,
  });

  return (
    <Layout h="100vh" justify="center" overflowY="auto" p={6} w="100vw">
      <Box maxW="1200px" w="80%">
        <ContentContainer
          loadingContent={{
            isLoading: isFetching,
            message: intl.formatMessage({
              id: 'ExternalDocumentViewer.loadingDocument',
              defaultMessage: 'Loading document…',
              description: 'Loading message for external document viewer',
            }),
          }}
          placeholderContent={
            error
              ? {
                  icon: 'status-warning',
                  message: coerceRtkqError(error).message,
                }
              : undefined
          }
        >
          <>{file && <DocumentViewer file={file} />}</>
        </ContentContainer>
      </Box>
    </Layout>
  );
};

export default Page;
